// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CreditMemoNumberCriteria from './credit-memo-number-criteria';
import CreditMemoPinCriteria from './pin-criteria';
import CreditMemoWorkOrderCriteria from './work-order-criteria';
import Criteria from '../../state/criteria';

const CreditMemoPrimaryInputCriteriaSection = props =>
    <div className='credit-memo-primary-input-criteria'>
        <CreditMemoPinCriteria
            handlePinInputChange={props.handlePinInputChange}
            pinValue={props.criteria.pin}
        />
        <CreditMemoNumberCriteria
            creditMemoValue={props.criteria.creditMemo}
            handleCreditMemoNumberInputChange={props.handleCreditMemoNumberInputChange}
        />
        <CreditMemoWorkOrderCriteria
            handleInputChange={props.handleFirstWorkOrderInput}
            label='WORK_ORDER_ONE'
            placeHolderText='WORK_ORDER_ONE'
            value={props.criteria.workOrderOne}
        />
    </div>;

CreditMemoPrimaryInputCriteriaSection.displayName = 'CreditMemoPrimaryInputCriteriaSection';
CreditMemoPrimaryInputCriteriaSection.propTypes = {
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    handleCreditMemoNumberInputChange: PropTypes.func.isRequired,
    handleFirstWorkOrderInput: PropTypes.func.isRequired,
    handlePinInputChange: PropTypes.func.isRequired
};

export default CreditMemoPrimaryInputCriteriaSection;



// WEBPACK FOOTER //
// ./src/reports/credit-memo/components/credit-memo-report-criteria/primary-input-criteria-section.js